import abcRoles from '@/app/abc/roles.js'
export default [
  {
    path: '/abc',
    name: 'abc',
    component: () => import('@/app/abc/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', active: true, i18n: 'ABC.Title' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi',
    name: 'abc-kpi',
    component: () => import('@/app/abc/kpi.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/', i18n: 'ABC.Title' },
        { title: 'KPI', active: true, i18n: 'ABC.KpiTitle' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi/opex',
    name: 'abc-kpi-opex',
    component: () => import('@/app/abc/kpi.vue'),
    props: {
      kpiId: 1
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/abc', i18n: 'ABC.Title' },
        { title: 'OPEX', active: true, i18n: 'ABC.OPEX.Title' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi/opex/ugmining',
    name: 'abc-kpi-opex-ugmining',
    component: () => import('@/app/abc/kpi.vue'),
    props: {
      kpiId: 2
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/abc', i18n: 'ABC.Title' },
        { title: 'OPEX',  url: '/abc/kpi/opex', i18n: 'ABC.OPEX.Title' },
        { title: 'UGMining', active: true, i18n: 'ABC.OPEX.UGMining' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi/opex/ugmining/development',
    name: 'abc-kpi-opex-ugmining/development',
    component: () => import('@/app/abc/kpi.vue'),
    props: {
      kpiId: 3
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/abc', i18n: 'ABC.Title' },
        { title: 'OPEX',  url: '/abc/kpi/opex', i18n: 'ABC.OPEX.Title' },
        { title: 'UGMining', url: '/abc/kpi/opex/ugmining', i18n: 'ABC.OPEX.UGMining' },
        { title: 'Development', active: true, i18n: 'ABC.Development.Title' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi/opex/ugmining/development/drilling',
    name: 'abc-kpi-opex-ugmining-development-drilling',
    component: () => import('@/app/abc/kpi.vue'),
    props: {
      kpiId: 4
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/abc', i18n: 'ABC.Title' },
        { title: 'OPEX',  url: '/abc/kpi/opex', i18n: 'ABC.OPEX.Title' },
        { title: 'UGMining', url: '/abc/kpi/opex/ugmining', i18n: 'ABC.OPEX.UGMining' },
        { title: 'Development', url: '/abc/kpi/opex/ugmining/development', i18n: 'ABC.Development.Title' },
        { title: 'Drilling', active: true, i18n: 'ABC.Development.Drilling' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Dashboard'
    }
  },
  {
    path: '/abc/kpi/test',
    name: 'abc-kpi-test',
    component: () => import('@/app/abc/test.vue'),
    props: {
      kpiId: 1
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Activity Base Costing', url: '/abc', i18n: 'ABC.Title' },
        { title: 'KPI', active: true, i18n: 'ABC.KpiTitle' }
      ],
      requireAuth: true,
      requireRoles: abcRoles.readers,
      pageTitle: 'ABC Test'
    }
  }
]